import { BASE_BE_URL } from "../../lib/sessionClient";

// export const ALL_COMPLAINT = BASE_BE_URL + "/complaint/all";
// export const COMPLAINT_SETUP = BASE_BE_URL + "/complaint/setup";
// export const VISIT_SETUP = BASE_BE_URL + "/visit/setup";
// export const ADD_COMPLAINT = BASE_BE_URL + "/complaint";
// export const ADD_VISIT = BASE_BE_URL + "/visit";
// export const GET_CYLINDERS = BASE_BE_URL + "/cylinder/station/";
// export const ALL_SITE = BASE_BE_URL + "/station/all";
// export const ALL_SITE_BY_USER = BASE_BE_URL + "/station/all-byuser";
// export const ADD_OPERATOR = BASE_BE_URL + "/station/operator";
// export const COMPLAINT_CHECK = BASE_BE_URL + "/complaint/check";
// export const VISIT_CHECK = BASE_BE_URL + "/visit/check";
// export const VISIT_PENDING = BASE_BE_URL + "/visit/check/pending";
// export const VISIT_HISTORY = BASE_BE_URL + "/visit/history/";
// export const COMPLAINT_PENDING = BASE_BE_URL + "/complaint/check/pending";
// export const COMPLAINT_REMARK = BASE_BE_URL + "/complaint/remark";
// export const VISIT_REMARK = BASE_BE_URL + "/visit/remark";
// export const SITE_DOWNLOAD_TEMPLATE =
//   BASE_BE_URL + "/station/bulk/template";
// export const UPLOAD_STATION_BULK = BASE_BE_URL + "/station/bulk";
// export const DELETE_SITE_OPERATOR = BASE_BE_URL + "/station/operator/";
// export const CYLINDER_SETUP = BASE_BE_URL + "/cylinder/history/setup"
// export const VISIT_PDF = BASE_BE_URL + "/visit/"
export const VISIT_REPORT = BASE_BE_URL + "/station/visit-report";
export const VISIT_CYLINDER_CHANGE =
  BASE_BE_URL + "/visit/cylinderChange-report";
export const ADD_VHEICLE_READING = BASE_BE_URL + "/vehicle-log";
export const VIEW_VHEICLE_READINGS = BASE_BE_URL + "/vehicle-log/all";
export const PENDING_VHEICLE_READINGS =
  BASE_BE_URL + "/vehicle-log/check/pending";
export const CHECK_VHEICLE_READINGS = BASE_BE_URL + "/vehicle-log/check";
export const VHEICLE_READINGS_HISTORY = BASE_BE_URL + "/vehicle-log/history";
export const VEHICLE_READING_SETUP = BASE_BE_URL + "/station/setup/byuser";
